import type { KhoaDich } from '../../i18n';
import type { Tang } from './chung/nghiep-vu/types';

/** Nhãn tầng ghi của một bước trong chuỗi xử lý (CLAUDE.md: "Bảng tông nằm ở `modules/<phân hệ>/constants.ts`"). */
export const NHAN_TANG: Record<Tang, KhoaDich> = {
  gateway: 'nktv.tang.gateway',
  nghiep_vu: 'nktv.tang.nghiep_vu',
};
